const skillsApi = '/skills';

export const getSkillsPath = () => `${skillsApi}`;
